import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

// 관리자 탭 컴포넌트
import AdminUsersTab from '../components/admin/AdminUsersTab';
import AdminPremiumTab from '../components/admin/AdminPremiumTab';
import AdminEmployersTab from '../components/admin/AdminEmployersTab';
import AdminProviderApprovalTab from '../components/admin/AdminProviderApprovalTab';
import AdminProviderCommissionTab from '../components/admin/AdminProviderCommissionTab';
import AdminDegreeReviewTab from '../components/admin/AdminDegreeReviewTab';
import AdminCertificateReviewTab from '../components/admin/AdminCertificateReviewTab';
import AdminEducationCategoriesTab from '../components/admin/AdminEducationCategoriesTab';
import AdminBadgeTreeTab from '../components/admin/AdminBadgeTreeTab';
import AdminSiteSettingsTab from '../components/admin/AdminSiteSettingsTab';
import AdminPremiumInquiriesTab from '../components/admin/AdminPremiumInquiriesTab';
import AdminSidebar from '../components/AdminSidebar';
import Header from '../components/Header';
import MainTabsNav from '../components/MainTabsNav';
import Footer from '../components/Footer';

export default function AdminPage() {
  const { user, isAuthenticated } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  // 비로그인 또는 관리자가 아니면 홈으로 리다이렉트
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    if (user?.role !== 'admin') {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, user, navigate]);

  if (!isAuthenticated || user?.role !== 'admin') {
    return null;
  }

  // URL에 따라 탭 렌더링
  const renderTab = () => {
    const pathname = location.pathname;

    if (pathname === '/admin/premium') {
      return <AdminPremiumTab />;
    }

    if (pathname === '/admin/employers') {
      return <AdminEmployersTab />;
    }

    if (pathname === '/admin/provider-approvals') {
      return <AdminProviderApprovalTab />;
    }

    if (pathname === '/admin/provider-commission') {
      return <AdminProviderCommissionTab />;
    }

    if (pathname === '/admin/degree-review') {
      return <AdminDegreeReviewTab />;
    }

    if (pathname === '/admin/certificate-review') {
      return <AdminCertificateReviewTab />;
    }

    if (pathname === '/admin/education-categories') {
      return <AdminEducationCategoriesTab />;
    }

    if (pathname === '/admin/badge-tree') {
      return <AdminBadgeTreeTab />;
    }

    if (pathname === '/admin/premium-intro') {
      return <AdminSiteSettingsTab />;
    }

    if (pathname === '/admin/premium-inquiries') {
      return <AdminPremiumInquiriesTab />;
    }

    // 기본: 회원 정보 관리
    return <AdminUsersTab />;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <MainTabsNav className="mt-16" />
      <div className="flex flex-1 max-w-[1440px] mx-auto w-full">
        {/* 공유 사이드바 */}
        <AdminSidebar />

        {/* 메인 콘텐츠 */}
        <main className="flex-1 min-w-0 p-6 sm:px-10 lg:px-16">
          {renderTab()}
        </main>
      </div>
      <Footer />
    </div>
  );
}
